<template >
  <li class="w-full"  >
    <div class="flex">
      <router-link :to="{ name: item.path } " 
        class="w-full parent group flex items-center pr-1 hover:bg-primary-100 dark:hover:bg-darkblue-600 active:bg-primary-200 dark:active:bg-primary-200 animate-hover rounded-sm"
        :tabindex="item.disabled ? -1 : 0"
        :aria-current="$route.name === item.path ? 'page' : null"
        :aria-label="item.name"
        >
        <span
          class="link-icon flex-none w-8 h-10 md:h-8 flex items-center justify-center rounded-full dark:group-hover:text-primary"
        >
          <base-icon :name="item.icon" v-if="item.icon" />
        </span>
        <span class="link-name-wrapper w-full overflow-hidden pl-1">
          <span class="link-name group-hover:text-primary-900 group-hover:font-bold dark:group-hover:text-primary" :data-v-step="tourStep" aria-hidden>
            {{ item.name }} 
          </span>
        </span>
        <span 
          v-show="actualFilterNav && item.path === 'notifications'"
          class="ml-auto w-8 h-7 flex items-center justify-center cursor-p hover:bg-primary-200 dark:hover:bg-darkblue-600 rounded"
          v-popover:popover
          tabindex="-1"
          >
          <base-icon name="filter" size="sm" custom="text-secondary-600"/>
        </span>
        <el-popover
          :tabindex="-1"
          ref="popover"
          placement="right"
          width="320"
          trigger="hover"
          popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
          >
          <div>
            <div v-if="actualFilterNav">
              <div class="flex items-center justify-between">
                <span class="text-lg">Filtro de cliente</span>
                <base-button-icon
                  ariaLabel="Eliminar filtro de cliente"
                  @click="resetNavFilter()"
                  name="cross"
                  iconSize="xs"
                  size="xs"
                  mode="primary-phantom"
                  class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                />
              </div>
              <div class="flex items-center justify-between">
                <span>{{actualFilterNav.idCliente}} - {{actualFilterNav.Nombre}}</span>
              </div>
            </div>
            <div v-else>
              <span>Ningún filtro seleccionado</span>
            </div>
          </div>    
        </el-popover>
      </router-link>
      <button
        v-if="hasLinks"
        @click.prevent="toggle"
        class="arrow ml-auto w-8 h-7 flex-none flex items-center justify-center cursor-p hover:bg-primary-200 dark:hover:bg-darkblue-600 rounded animate-hover"
        :aria-expanded="active ? 'true' : 'false'"
        aria-haspopup="true"
        :aria-controls="'submenu-' + item.name"
        :aria-label="'Alternar submenú de ' + item.name"
        tabindex="0"
      >
        <span
          :class="{ 'rotate-180': active }"
          class="transform transition-transform duration-300 dark:text-darkblue-400 dark:hover:text-primary">
          <base-icon 
            name="chevrondown" 
            size="sm" 
            :title="active ? 'Contraer submenú' : 'Desplegar submenú'" 
            />
        </span>
      </button>
    </div>
    <template v-if="hasLinks">
      <transition
        name="list-links"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <ol class="overflow-hidden child-navigation mb-8" v-if="active"
        >
          <base-aside-nav-item-group :item="group" v-for="group in itemsWithSubMenu" :key="group.name" :title="group.name"
            />
          <base-aside-nav-item-link 
            v-for="link in itemsWithLink" :key="link.name"  
            :link="link"
            />
        </ol>
      </transition>
    </template>
  </li>
</template>

<script>
import { bus } from '@/main'

export default {
  name: 'aside-nav-item',
  props: {
    item: {
      type: [Object, Array],
      required: true
    },
    role: {
      type: String,
      default: null
    }

  },
  data: function () {
    return {
      // Posible futuro cambio a store para mantener el estado actual
      // active: this.item?.name !== 'Papelera'
      active: this.item.name === 'Papelera' ? this.$store.getters['app/openTrash'] : true,
    }
  },
  computed: {
    hasLinks: function () {
      return this.item.sc.length > 0
    },
    tourStep () {
      if (this.item.path === 'certificates') return 1
      if (this.item.path === 'companies') return 3
      return 99999
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    itemsWithSubMenu () {
      if (this.item.subMenu) return this.item.sc 
      return []
    },
    itemsWithLink () {
      if (!this.item.subMenu) return this.item.sc 
      return []
    },
  },
  methods: {
    resetNavFilter () {
      this.$store.dispatch('app/updateidClienteFilterNav', null)
      bus.$emit('changeIt', 'changed menu')
    },
    toggle: function () {
      this.active = !this.active
      if (this.item.name === 'Papelera') {
        this.$store.dispatch('app/setopenTrash', this.active)
      }
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
a.parent {
  @apply pl-4 pr-5;
}
[data-type='main'] {
  a.parent {
    @apply pl-3 pr-1;
  }
}
a.child {
  @apply pl-18;
}
[data-type='main'] {
  a.child {
    @apply pl-11;
  }
}

.group-container{
  @apply bg-primary-50;
  @apply dark:bg-darkblue;
}
[data-type='main'] {
  .group-container{
    @apply bg-white;
    @apply dark:bg-darkblue-900;
  }
}
.animate-hover {
  @apply transition-colors duration-300;
}
.animate-all {
  @apply transition-all duration-300;
}
.cover-subnav {
  @apply border-secondary-100;
}
.span-nav-link-container{
  @apply border-secondary-200;
}
.link-icon {
  @apply text-secondary-500 dark:text-darkblue-400;
}
.link-name {
    @apply text-secondary-800 dark:text-darkblue-200 font-medium;

  }
.link-name.color-link-disabled{
  @apply text-secondary-600;
}
.router-link-active {
  .link-icon {
    @apply text-secondary dark:text-darkblue-200;
  }
  .link-name {
    @apply text-secondary-800 dark:text-darkblue-100 font-bold;
  }
  .cover-subnav {
    @apply border-primary;
  }
  .span-nav-link-container{
    @apply border-primary;
    border-left-width: 4px!important;
  }
}
.rotate-180 {
  transform: rotate(-180deg);
}
.list-links-enter-active,
.list-links-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.list-links-enter,
.list-links-leave-to {
  height: 0 !important;
}
</style>
